import {
  getParams,
  getLocal,
  isWorkWeChat,
  isWeChat,
  isIOS,
  isMiniProgram,
} from '@/utils/utils'
import config from '@/config'
import { CUSTOM_LIVE } from '@/utils/customLive'
import moment from 'moment'
import { couponFilterParamsNew } from '@/store/getters'
const {
  zbid,
  zid,
  zbId,
  tpid,
  topicId,
  topicid,
  tpId,
  cid,
  isScreen,
  generalizeShopId,
  GeneralizeShopZbid,
  generalizeShopZbid,
  liveid,
  liveId,
} = getParams()
const zbvd_local = getLocal(`zbvd_${zbid}`) || {}
window.zbvd = Object.assign(zbvd_local, {
  zbid: Number(zbid || zid || zbId || liveid || liveId) || 75999,
  tpid: Number(tpid || topicId || topicid || tpId) || 0,
  cid: Number(cid) || 0,
  isScreen: Number(isScreen), // 判读横竖屏 0--竖屏 1--横屏
  generalizeShopId: Number(generalizeShopId) || 0,
  generalizeShopZbid: Number(GeneralizeShopZbid || generalizeShopZbid) || 0,
  zbuid: 0,
})
window.zbvd.customLive = CUSTOM_LIVE[window.zbvd.zbid] || '' // 定制直播间名称
window.userInfo = {}
const state = {
  getSelfVerifyConfigActionPrevParams: {},
  wxMaxPay: 6000,
  zbvd: window.zbvd,
  userInfo: window.userInfo,
  vzandesc: '微赞提供技术支持',
  cdnPath: config.cdnPath,
  env: window.env,
  isWorkWx: isWorkWeChat(),
  isWx: isWeChat(),
  platform: window.navigator.platform.toLowerCase(),
  isIOS: isIOS(),
  isSignIn: false, // 签到状态
  isSignUp: false, // 购票历史
  isUserNoPayment: false, // 峰会展会 用户是否有未付款订单
  isTicket: true,
  playbackType: 0,
  expoActivity: {}, // 峰会展会活动详情
  expoHasLive: false, // 是否有主办方直播正在进行中
  audioPlaying: false, // 全局控制多个音频播放开关
  isMiniProgram: false,
  // 独立域名
  isPrivateDomain: ['.vzan.com', '192.', 'localhost'].every(
    el => !location.host.includes(el)
  ),
  storeStyleInfo: null,
  customConfig: {},
  // 订单统计筛选条件
  orderFilterParams: {
    orderId: '',
    pageIndex: 1,
    pageSize: 10,
    startTime: moment()
      .subtract(7 - 1, 'days')
      .format('YYYY-MM-DD 00:00:00'),
    endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
    zbId: zbvd.zbid,
    followLevel: 1,
    deliveryType: -1,
    deliveryTypeList: [],
    orderStatus: -999,
    orderStatusList: [],
    followType: 0,
    topicId: '',
    userId: '',
    followId: '',
    relevanceFollowId: '', // 关联代理id
    phone: '',
    // orderSegmentType: [200, 1227, 240, 1212, 1288, 1211, 1315, 1806, 1807],
    orderSegmentType: [], // 产品说要默认查全部
    // verifyStatus: -1,
    verifyStatusList: [],
    serachTimeType: 0,
    receiveUserName: '',
    deliveryNo: '',
    tradeNo: '',
    time: -1,
    isAgentTakeOrder: -1,
    selectValue: 'nickName', // 这个是搜索框的搜索类型，默认买家昵称 搜索
  },
  orderFilterParamsNew: {
    // orderId: '',
    pageIndex: 1,
    pageSize: 10,
    // startTime: moment()
    //   .subtract(7 - 1, 'days')
    //   .format('YYYY-MM-DD 00:00:00'),
    // endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
    zbId: zbvd.zbid,
    followLevel: 1,
    deliveryType: -1,
    deliveryTypeList: [],
    orderStatus: -999,
    orderStatusList: [],
    followType: 0,
    // topicId: '',
    // userId: '',
    // followId: '',
    // relevanceFollowId: '', // 关联代理id
    // phone: '',
    orderSegmentType: [],
    // verifyStatus: -1,
    verifyStatusList: [],
    serachTimeType: 0,
    searchTimeSortType: 0,
    // receiveUserName: '',
    // deliveryNo: '',
    // tradeNo: '',
    // time: -1,
    isAgentTakeOrder: [-1],
    // selectValue: 'nickName', // 这个是搜索框的搜索类型，默认买家昵称 搜索
  },
  // 优惠券统计筛选条件
  couponFilterParams: {
    dateType: 1,
    classIds: [], // 核销优惠券 才有的类目 筛选
    couponName: '', // 优惠券名称搜索
    lineType: 0, // 0-核销优惠券 2-商品优惠券
    receiveDate: [
      moment()
        .subtract(7 - 1, 'days')
        .format('YYYY-MM-DD 00:00:00'),
      moment().format('YYYY-MM-DD 23:59:59'),
    ],
    customReciveDate: false, // 是否为自定义时间
  },
  // 优惠券统计筛选条件
  couponFilterParamsNew: {
    dateType: 1,
    classIds: [], // 核销优惠券 才有的类目 筛选
    couponName: '', // 优惠券名称搜索
    lineType: 0, // 0-核销优惠券 2-商品优惠券
    receiveDate: [
      moment()
        .subtract(7 - 1, 'days')
        .format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD'),
    ],
    // useDate: [],
  },
  // 商品统计筛选条件
  goodsFilterParams: {
    deliveryType: 1,
    dateType: 'orderTime',
    agentId: '',
    agentLevel: 0,
    verifyStatus: [],
    orderStatus: [],
    customDateFormData: [
      moment(new Date())
        .subtract(7 - 1, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    ],
    goodsName: '',
    orderSegmentType: [],
    productId: '', // 单个选择时高亮选中商品id
    orderStatusList: [],
    productIds: [], // 传递给后端的商品id集合
  },
  isFetchAgentAuthList: false, // 是否获取过代理中心权限
  // 商品统计筛选条件(new)
  goodsFilterParamsNew: {
    deliveryType: 1,
    // dateType: 'orderTime',
    agentId: '',
    agentLevel: [''],
    verifyStatus: [],
    orderStatus: [],
    // customDateFormData: [
    //   moment(new Date())
    //     .subtract(7 - 1, 'days')
    //     .format('YYYY-MM-DD HH:mm:ss'),
    //   moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    // ],
    goodsName: '',
    orderSegmentType: [],
    productId: '', // 单个选择时高亮选中商品id
    orderStatusList: [],
    productIds: [], // 传递给后端的商品id集合
  },
  agentAuthList: [], // 代理中心权限
  isAgentGray: false, // 是否是代理中心灰度直播间
  authDataAndAgentSetting: {},
  isForBiddenLive: false, // 是否是封禁直播间
  personalBalance: 0,
  showedBindStorePopup: false,
  guokeCustomization: false,
  cachedComponents: ['promotion', 'Workbench', 'AgentLayout'], // 缓存路由
  agentTeamConfig: {
    // 国科团队管理身份信息
    isLeader: false,
    roleType: 0, // 当前选择身份 0：未选择 1 负责人 2 代理
  },
  integral: {
    isRequest: false,
    integralInfo: null,
  },
  selfVerifyConfig: {}, // H5端获取用户自主核销配置
  fontSizeScale: 0, // 代理设置字体大小 0-默认 1-中 2-大
  /** 直播间支持运费险 */
  isSupportFreightInsurance: false,
  isAgent: false,
  /**  个人中心-行业字段（与代理中心不同） 0 通用、1 零售生鲜*/
  businessModel: 0,
  payThirdType: -1, // 直播间第三方支付类型 0：连连 1：易宝
  iBanShareInline: false // 是否屏蔽内嵌H5的分享链接和海报（小程序开启屏蔽H5功能使用）
}

;(async () => {
  state.isMiniProgram = isMiniProgram()
})()
export default state
